import { useEffect } from 'react';

/**
 * Two small mobile-layout class toggles for the calendar, colocated.
 * Both were their own ~21-line single-consumer hook file
 * (useBodyModalOpenClass / useCalendarFullscreenClass); merged here since
 * they share the same shape (toggle a document class from a parent-owned
 * boolean) and the same single consumer, EventListModule.
 *
 * Both effect bodies and dependency arrays are byte-identical to the
 * originals — this is colocation only, not a behavior change.
 */

/**
 * Hide the mobile header/footer while a calendar modal is open by toggling the
 * `modal-open` class on <body>. Pass `isModalOpen` (the parent keeps owning the
 * derived boolean); the cleanup removes the class.
 */
export function useBodyModalOpenClass(isModalOpen: boolean) {
  useEffect(() => {
    if (!isModalOpen) return;

    document.body.classList.add('modal-open');

    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [isModalOpen]);
}

/**
 * Mobile calendar fullscreen: add the `calendar-fullscreen` class to <html> so
 * CSS can lock scroll while the compact layout is active. Pass `isMobile` (the
 * parent keeps owning the layout boolean).
 */
export function useCalendarFullscreenClass(isMobile: boolean) {
  useEffect(() => {
    if (isMobile) {
      document.documentElement.classList.add('calendar-fullscreen');
      return () => {
        document.documentElement.classList.remove('calendar-fullscreen');
      };
    }
    document.documentElement.classList.remove('calendar-fullscreen');
  }, [isMobile]);
}
